import { render, staticRenderFns } from "./SlideOptionImageButton.vue?vue&type=template&id=36c85404&scoped=true&"
import script from "./SlideOptionImageButton.vue?vue&type=script&lang=js&"
export * from "./SlideOptionImageButton.vue?vue&type=script&lang=js&"
import style0 from "./SlideOptionImageButton.vue?vue&type=style&index=0&id=36c85404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c85404",
  null
  
)

export default component.exports